<template>
  <div class="content-form position-relative">
    <v-container
      fluid
      class="p-left-container p-right-container"
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <div class="order-intro">
            <p class="order-title po-bold">
              <span style="color: #c9da2d;">[</span>
              Place Your Order
              <span style="color: #c9da2d;">]</span>
            </p>
            <p class="order-subtitle po-regular">
              Ready to order? Fill out the form with your details and what you'd like.
            </p>
            <div class="order-features">
              <div class="feature-item">
                <v-icon color="#dd4999" size="24">mdi-check-circle</v-icon>
                <span class="po-regular">We'll confirm your order shortly</span>
              </div>
              <div class="feature-item">
                <v-icon color="#dd4999" size="24">mdi-check-circle</v-icon>
                <span class="po-regular">Pickup or delivery available</span>
              </div>
            </div>
            <div class="call-box">
              <v-icon color="#c9da2d" size="28">mdi-phone</v-icon>
              <div>
                <p class="call-label po-regular mb-0">Or call us directly</p>
                <a href="tel:+17787922204" class="call-number po-bold">+1 (778) 792-2204</a>
              </div>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <form @submit.prevent="sendEmail">
            <div>
              <p class="txt-label po-regular">Name*</p>
              <v-text-field
                v-model="nombre"
                name="nombre"
                placeholder="Your name"
                solo
                dense
                hide-details=""
                class="mb-5 input-style"
                background-color="#262626"
              />
            </div>
            <div>
              <p class="txt-label po-regular">Email*</p>
              <v-text-field
                v-model="correo"
                name="correo"
                placeholder="Your email"
                solo
                dense
                hide-details=""
                class="mb-5 input-style"
                background-color="#262626"
              />
            </div>
            <div>
              <p class="txt-label po-regular">Phone*</p>
              <v-text-field
                v-model="telefono"
                name="telefono"
                placeholder="Your phone number"
                solo
                dense
                hide-details=""
                class="mb-5 input-style"
                background-color="#262626"
                @keypress="soloNumbers"
              />
            </div>
            <div>
              <p class="txt-label po-regular">Your Order*</p>
              <v-textarea
                v-model="comentarios"
                name="comentarios"
                placeholder="Describe your order (items, quantities, special requests...)"
                solo
                dense
                class="mb-3 input-style"
                rows="4"
                counter="500"
                background-color="#262626"
              />
            </div>
            <div class="content-button-contact display-flex align-items-center justify-content-center">
              <v-btn
                type="submit"
                :loading="bLoading"
                :disabled="!validateForm"
                class=" button-send"
              >
                Place Order
              </v-btn>
            </div>
          </form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  name: "OrderFormLayout",
  data() {
    return {
      //variables
      nombre: "",
      correo: "",
      telefono: "",
      comentarios: "",
      bLoading: false,
    };
  },
  methods: {
    sendEmail: function (e) {
      this.bLoading = true;

      emailjs
        .sendForm(
          "service_nhbz5lo",
          "template_ihais4g",
          e.target,
          "user_PIpQsjbgK2NtqIL9VXeoQ"
        )
        .then(
          (result) => {
            this.$swal(
              "Order Received!",
              "We'll contact you shortly to confirm your order.",
              "success"
            );

            this.bLoading = false;
            this.nombre = "";
            this.correo = "";
            this.telefono = "";
            this.comentarios = "";
          },
          (error) => {
            this.$swal(
              "Error!",
              "There was a problem sending your order. Please try again or call us directly.",
              "error"
            );

            this.bLoading = false;
            this.nombre = "";
            this.correo = "";
            this.telefono = "";
            this.comentarios = "";
          }
        );
    },
    soloNumbers: function (evt) {
      if (
        (evt.which != 8 && evt.which != 0 && evt.which < 48) ||
        evt.which > 57
      ) {
        evt.preventDefault();
      }
    },
  },
  computed: {
    validateForm: function () {
      return (
        this.nombre != "" &&
        this.correo != "" &&
        this.telefono != "" &&
        this.comentarios != ""
      );
    },
  },
};
</script>

<style>
.content-button-contact .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #dd4999 !important;
  opacity: 0.5;
  pointer-events: all;
  cursor: no-drop;
}

.content-form .input-style input::placeholder {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #ffffff !important;
  opacity: 0.2;
}

.content-form .input-style input:-ms-input-placeholder {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #ffffff !important;
  opacity: 0.2;
}

.content-form .input-style input::-ms-input-placeholder {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #ffffff !important;
  opacity: 0.2;
}

.content-form .input-style textarea::placeholder {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #ffffff !important;
  opacity: 0.2;
}

.content-form .input-style textarea:-ms-input-placeholder {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #ffffff !important;
  opacity: 0.2;
}

.content-form .input-style textarea::-ms-input-placeholder {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #ffffff !important;
  opacity: 0.2;
}

.content-form .input-style input {
  color: #fff !important;
  font-size: 14px;
}

.content-form .input-style textarea {
  color: #fff !important;
  font-size: 14px;
}
</style>

<style scoped>
.order-intro {
  padding-right: 20px;
}

.order-title {
  font-size: 40px;
  color: #ffffff;
  margin-bottom: 20px;
}

.order-subtitle {
  font-size: 20px;
  color: #ffffff;
  opacity: 0.8;
  margin-bottom: 30px;
  line-height: 1.5;
}

.order-features {
  margin-bottom: 30px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  color: #ffffff;
  font-size: 16px;
}

.call-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #191919;
  padding: 20px 25px;
  border-radius: 12px;
  border: 1px solid #333;
}

.call-label {
  font-size: 14px;
  color: #ffffff;
  opacity: 0.6;
}

.call-number {
  font-size: 22px;
  color: #dd4999;
  text-decoration: none;
  transition: color 0.2s;
}

.call-number:hover {
  color: #c9da2d;
  text-decoration: underline;
}

.content-form {
  background-color: #000;
  padding: 100px 0px 0px 0px;
  overflow: hidden;
}

.button-send {
  width: 100%;
  background: #dd4999 0% 0% no-repeat padding-box !important;
  border-radius: 30px;
  text-align: left;
  font-size: 16px !important;
  text-transform: initial;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}

.txt-label {
  text-align: left;
  color: #fff;
  font-size: 12px;
  letter-spacing: 0px;
  opacity: 1;
  margin-bottom: 0px;
}

@media (max-width: 960px) {
  .order-intro {
    padding-right: 0;
    margin-bottom: 40px;
  }

  .order-title {
    font-size: 30px;
    text-align: center;
  }

  .order-subtitle {
    font-size: 18px;
    text-align: center;
  }

  .order-features {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .call-box {
    justify-content: center;
  }

  .call-number {
    font-size: 20px;
  }
}
</style>
